import styled from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';
import { formatDuration, formatPricePerHour } from '@wecasa/common/src/utils/formatting';

import type { CategoryCleaningProps } from '@wecasa/customer/src/components/basket/types';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { CategoryLine, PrestationsListElement } from '../../../../common/common';

const t = translate('basket.cleaning.services');

const PrestationsRecap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const PrestationsList = styled.ul`
  margin: 0;
  padding-left: 15px;
`;

const Category = ({
  cleaningPrestation,
  cleaningPrestationOptions,
  duration,
  hasPets,
  frequencyText,
}: CategoryCleaningProps) => (
  <CategoryLine>
    <PrestationsRecap>
      <PrestationsList>
        <PrestationsListElement>
          <Text>{`• ${cleaningPrestation?.title || ''}`}</Text>
        </PrestationsListElement>
        {!!frequencyText && (
          <PrestationsListElement>
            <Text>{`• ${frequencyText}`}</Text>
          </PrestationsListElement>
        )}
        {duration && (
          <PrestationsListElement>
            <Text>{`• ${t('.duration', { duration: formatDuration(duration) })}`}</Text>
          </PrestationsListElement>
        )}
      </PrestationsList>
      <Text.SM color={colors.neutral50}>{formatPricePerHour(cleaningPrestation.pricing.user_price)}</Text.SM>
    </PrestationsRecap>
    <PrestationsList>
      {cleaningPrestationOptions?.map((option) => (
        <PrestationsListElement key={option.reference}>
          <Text>{`• ${option.title}`}</Text>
          {option.pricing.user_price > 0 && (
            <Text.SM color={colors.neutral50}>{formatPricePerHour(option.pricing.user_price)}</Text.SM>
          )}
        </PrestationsListElement>
      ))}
      {hasPets && (
        <PrestationsListElement>
          <Text>{`• ${t('.pets')}`}</Text>
        </PrestationsListElement>
      )}
    </PrestationsList>
  </CategoryLine>
);

export default Category;
